import Link from 'next/link'
import React from 'react'
import BlogPostCard from '../BlogPostCard'
import {
  BlogReadMoreContainer,
  BlogReadMoreHeader,
  BlogReadMoreLink,
  BlogReadMorePosts,
  BlogReadMoreTitle
} from './BlogReadMore.styles'

export const BlogReadMore = ({ posts = [] }) => {
  if (posts.length === 0) return null

  return (
    <BlogReadMoreContainer>
      <BlogReadMoreHeader>
        <BlogReadMoreTitle>Read More</BlogReadMoreTitle>
        <Link href="/blog">
          <BlogReadMoreLink>See All</BlogReadMoreLink>
        </Link>
      </BlogReadMoreHeader>
      <BlogReadMorePosts>
        {posts.map(post => {
          return <BlogPostCard key={post.id} post={post.attributes} />
        })}
      </BlogReadMorePosts>
    </BlogReadMoreContainer>
  )
}
